import {
  FocusEvent,
  ChangeEventHandler,
  FC,
  FormEventHandler,
  useEffect,
  useState,
} from "react";
import { SearchField } from "../search-field";
import { SearchFormProps } from "./types";

export const SearchForm: FC<SearchFormProps> = ({
  onSubmit,
  onQueryClear,
  className,
  searchFieldType,
  onChange,
  searchText,
  onFocus,
  onSearchFieldBlur,
  clearButtonClassName,
}) => {
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (searchText !== undefined && searchText !== query) {
      setQuery(searchText);
    }
  }, [searchText, query]);

  const handleChange: ChangeEventHandler<HTMLInputElement> = ({
    target: { value },
  }) => {
    setQuery(value);

    if (onChange) {
      onChange(value);
    }
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault();

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    onSubmit(query);
  };

  const handleClear = () => {
    setQuery("");

    if (onQueryClear) {
      onQueryClear();
    }
  };

  const handleFocus = () => {
    if (onFocus) {
      onFocus(query);
    }
  };

  const handleSearchFieldBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (onSearchFieldBlur) {
      onSearchFieldBlur(e);
    }
  };

  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      onSubmit(query);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={className} onFocus={handleFocus}>
      <SearchField
        value={query}
        onChange={handleChange}
        onClear={handleClear}
        onBlur={handleSearchFieldBlur}
        onKeyDown={handleKeyDown}
        type={searchFieldType}
        clearButtonClassName={clearButtonClassName}
      />
    </form>
  );
};
